import './CareersStyle.css'
import OpenPositions from "./OpenPosition";
import WhyUs from "./WhyUs";

function Careers() {
  // WhatsApp contact info
  const whatsappNumber = "918084378326";
  const whatsappMessage = "Hello%20I%27m%20interested%20in%20career%20opportunities%20at%20your%20company.%20Can%20you%20please%20share%20more%20details%3F";

  // Handle WhatsApp contact
  const handleWhatsAppContact = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank');
  };

  // Smooth scroll to open positions section
  const scrollToPositions = () => {
    const positionsSection = document.getElementById('open-positions-section');
    if (positionsSection) {
      const targetPosition = positionsSection.offsetTop;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      let startTime = null;

      const animation = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeOutCubic(Math.min(timeElapsed, 800) / 800);
        window.scrollTo(0, startPosition + distance * run);
        if (timeElapsed < 800) requestAnimationFrame(animation);
      };

      requestAnimationFrame(animation);
    }
  };

  // Easing function for smooth scroll
  const easeOutCubic = (t) => {
    return 1 - Math.pow(1 - t, 3);
  };

  return (
    <div className="container-fluid careers-container p-0">
      {/* ========== HERO SECTION START ========== */}
      <section className="careers-hero-section">
        <div className="container careers-hero-container mt-5">
          <h1 className="careers-hero-title">Be a part of this diligent team.</h1>
          <p className="careers-hero-description">
            Our promise of designing tomorrow together is at the heart of everything we do.
            Join us in building innovative solutions that make a difference.
          </p>
          {/* <div className="careers-hero-buttons">
            <button className="careers-btn-primary" onClick={scrollToPositions}>View Open Positions →</button>
            <button className="careers-btn-secondary" onClick={handleWhatsAppContact}>Contact Us on WhatsApp</button>
          </div> */}
          <button className="careers-hero-arrow-down" onClick={scrollToPositions} aria-label="Scroll to positions">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
        </div>
      </section>
      {/* ========== HERO SECTION END ========== */}

      <div id="open-positions-section">
        <OpenPositions />
      </div>
      <WhyUs />
    </div>
  );
}

export default Careers;